export const team = [
  {
    name: "Competitive Programming",
    members: [
      { name: "J Atulya" },
      { name: "Adil Mohamed M P" },
      { name: "Hemant Antony" },
      { name: "Pradyumn R Pai" },
      { name: "Gautham N Pai" },
      { name: "Lovebin Joseph Robin" },
      { name: "Srilakshmi R" },
      { name: "Maria Susan Mathew" },
      { name: "Sonia Stine" },
      { name: "Sutosh kumar" },
      { name: "Binitha Babu" },
      { name: "Riya Mary Jose" },
      { name: "Ananya P" },
      { name: "Suhana Sulfeekar" },
    ],
  },
  {
    name: "Tech Team",
    members: [
      { name: "Sthuthi Sambath" },
      { name: "Jeslia Rose" },
      { name: "Keerthana J" },
      { name: "Rohit Anish" },
      { name: "Khushi Nilesh Ved" },
      { name: "Anish Pillai" },
      { name: "Rahul Anup Varma" },
      { name: "Riya Mary Jose" }
    ]
  },
  {
    name: "Content Team",
    members: [
      { name: "Anjana S Nair" },
      { name: "Neehara Prajesh" },
      { name: "Nanditha S" },
      { name: "Alex Vargese" },
      { name: "Surabhi Thiruvoth" },
      { name: "Binitha Babu" }
    ],
  },
  {
    name: "Design Team",
    members: [
      { name: "Jaimy Renji" },
      { name: "Riya Mary Jose" },
      { name: "Jeslia Rose" },
      { name: "Anavadya N Lakshmi" },
      { name: "Angel Mary Binu" },
      { name: "Nanditha S" },
      { name: "Geo Jose P" },
      { name: "Medha K" },
      { name: "K V Varun Krishnan" },
      { name: "Vrishti V Shah" }
    ],
  },
  {
    name: "Outreach Team",
    members: [
      { name: "JACOB M P" },
      { name: "Jeff George Mathew" },
      { name: "Feba Sherly George" },
      { name: "Anna Binoy" },
      { name: "Steve B George" },
      { name: "Alita Sabu Paul" },
      { name: "Nandana Biju" },
      { name: "Pooja Rajeev" },
      { name: "Adhish Joseph Shinu" },
      { name: "Jesa Dileep Philip" },
      { name: "Elsa Susan Jain" },
      { name: "Anagha S A" },
      { name: "Alan tom sabu" },
      { name: "Athulya v" }
    ],
  },
  {
    name: "Events Team",
    members: [
      { name: "Yaswanth Rajeev" },
      { name: "Waffa M" },
      { name: "Vaidehi Nair Krishnakumar" },
      { name: "Niju George" },
      { name: "Pranav K Pradeep" },
      { name: "Nora Babu Kavukattu" },
      { name: "Rohith P S" },
      { name: "Sandra Sara Solomon" },
      { name: "Jensine Soji" },
      { name: "Hridhya K P" }
    ],
  },
  {
    name:"Marketing Team",
    members:[
      { name: "Aardra S" },
      { name: "Jeswin Joseph" },
      { name: "Nikhil Tomy" },
      { name: "Akash Abraham" },
      { name: "Alex Varghese" },
      { name: "Martin Joseph" },
      { name: "Anjana S Nair" }
    ]
  }
];
